package com.vamvisions.main.navigation

import androidx.compose.runtime.Composable
import com.vamvisions.main.core.presentation.navigation.Route
import com.vamvisions.main.core.presentation.navigation.toPath
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.A
import org.w3c.dom.HTMLAnchorElement

/**
 * An internal link. It is a real anchor, and a plain left click navigates in place. Modified or
 * non-left clicks keep the browser's behaviour, such as opening a new tab. A [fragment] is added to
 * the href, so the link also points at a section of the page; [onNavigate] must then keep it.
 */
@Composable
fun AppLink(
    route: Route,
    onNavigate: (Route) -> Unit,
    attrs: (AttrsScope<HTMLAnchorElement>.() -> Unit)? = null,
    fragment: String? = null,
    content: @Composable () -> Unit,
) {
    A(
        href = route.toPath() + fragment?.let { "#$it" }.orEmpty(),
        attrs = {
            onClick { event ->
                val isPlainLeftClick = event.button == 0.toShort() &&
                    !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey
                if (isPlainLeftClick) {
                    event.preventDefault()
                    onNavigate(route)
                }
            }
            attrs?.invoke(this)
        },
    ) {
        content()
    }
}
